import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ContentProvider } from "@/context/ContentContext";
import ProtectedRoute from "@/components/ProtectedRoute";

import Landing from "@/pages/Landing";
import Report from "@/pages/Report";
import Track from "@/pages/Track";
import Resources from "@/pages/Resources";
import PolicyDetail from "@/pages/PolicyDetail";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import EmployeeDashboard from "@/pages/EmployeeDashboard";
import SpecialistDashboard from "@/pages/SpecialistDashboard";
import CaseDetail from "@/pages/CaseDetail";
import ContentAdmin from "@/pages/ContentAdmin";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <ContentProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<ProtectedRoute><Landing /></ProtectedRoute>} />
            <Route path="/report" element={<ProtectedRoute><Report /></ProtectedRoute>} />
            <Route path="/track" element={<ProtectedRoute><Track /></ProtectedRoute>} />
            <Route path="/resources" element={<ProtectedRoute><Resources /></ProtectedRoute>} />
            <Route path="/resources/:slug" element={<ProtectedRoute><PolicyDetail /></ProtectedRoute>} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute roles={["employee"]}>
                  <EmployeeDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin"
              element={
                <ProtectedRoute roles={["specialist", "admin", "super_admin"]}>
                  <SpecialistDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/cases/:id"
              element={
                <ProtectedRoute roles={["specialist", "admin", "super_admin"]}>
                  <CaseDetail />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/content"
              element={
                <ProtectedRoute roles={["super_admin"]}>
                  <ContentAdmin />
                </ProtectedRoute>
              }
            />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
        </ContentProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
